import React from 'react';

import { Button, Icon } from '@column/column-ui-kit';

import { PageActions } from '~/app/Layout/PageFrameContext';
import { ROUTE } from '~/app/routes';
import { BankAccountsTable } from '~/components/BankAccountsTable';
import { useNavigate } from '~/lib/navigation';

export { convertOptionalDatesToRange } from '~/components/BankAccountsTable';

export const PageBankAccounts: React.FC = () => {
  const navigate = useNavigate();

  return (
    <>
      <PageActions>
        <Button
          onClick={() => navigate(ROUTE.COUNTERPARTIES)}
          icon={<Icon.UsersArrow />}
          size="small"
          variant="secondary"
        >
          Counterparties
        </Button>
        <Button onClick={() => navigate(`${ROUTE.BANK_ACCOUNTS}/edit`)} icon={<Icon.Plus />} size="small">
          Create Account
        </Button>
      </PageActions>

      <BankAccountsTable />
    </>
  );
};
